//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {map} from '@/assets/js/map'
export default {
  props:['id','modify','meetingType','refundL'],
  data() {
    return {
      form:{
        pageIndex:1,
        pageSize:10
      },
      applyVisible:false,
      timeNow:'',
      editList:[],
      extendList:[],
      apllyInfo:'',
      oprate: true,//服务商是否有操作
      timecha:'',
      waitInfoData: '',
      waitss:'',
      waits:'',
      yancVisible:false,
      yancInfo:'',
      payOrder:'',
      editDialog:false,
      editForm:{  //申请编辑
        finalProjectInvestment:'',
        finalProjectContent:'',
        finalProjectCraft:'',
        finalProjectDuration:''
      },
      extendVisible:false,
      formbz:{
        applyReason:'',
        addDay:''
      },
      rules:{

      }
    };
  },
  created(){
    this.map = map
  },
  mounted() {
    this.timeNow = new Date().getHours()
    if (this.tickers) {
      clearInterval(this.tickers);
    }
    this.getReresh()
    this.aduitInfo()
  },
  methods: {

    aduitInfo(){
      this.applyInfo()
      this.extendInfo()
    },

    // 查看取消的待办
    waitInfos(id) {
      this.$get('/activiti/act/audit/wait?userId=' + getSession('user').id+'&businessKey='+id, function(res){
        if (res.code == 200) {
          this.waitInfoData = res.data;
          if (res.data) {
            this.waits = res.data.taskName;
            this.waitss = 1
          } else {
            this.waits = '';
            this.waitss = 0
          }
        }
      })
    },
    
    // 申请编辑列表
    applyInfo(){
      this.$get('/tra/project/modify/list?traProjectId='+this.$route.query.id,function(res){
        if(res.code==200){
          this.editList= res.data
        }
      })
    },

    //查看编辑详情
    lookApply(id){
      this.waitInfos(id);
      this.applyVisible= true
      var timestampNow = new Date().getTime(); //当前时间戳
      var creattimestamp = '';
      this.$get('/tra/project/modify?id='+id,function(res){
        if(res.code==200){
          this.apllyInfo = res.data;
          var opinionList = res.data.opinionList;
          var caozuo = '';
          if(opinionList.length!=0){
            for (var i = 0; i < opinionList.length; i++) {
              caozuo += opinionList[i].isAgree
            }
            if (caozuo.indexOf('true') == -1) {
              if (caozuo.indexOf('false') == -1) {
                this.oprate = false
              }
            }
          }else{
             this.oprate = false
          }

          creattimestamp = Date.parse(res.data.createTime);
          this.timecha = timestampNow - creattimestamp;
        }
      })
    },

    // 撤销操作
    revoke(id) {
      this.$get('/tra/project/modify/revoke?id=' + id, function(res){
        if (res.code == 200) {
          this.$message.success('撤销操作成功!');
          this.applyVisible = false
          this.$parent.applyInfo()
          this.applyInfo();
        }else{
          this.$message.info(res.msg)
        }
      })
    },

    // 申请编辑,同意结果
    agreeResult() {
      this.waitInfoData.opinion = '1';
      this.$post('/activiti/act/audit/pass', this.waitInfoData, function(res){
        if (res.code == 200) {
          this.$message.success('操作成功!');
          this.applyAudit();
          this.applyVisible = false
        } else {
          this.$message.error(res.msg);
        }
      },true)
    },

    applyAudit() {
      var form = {
        businessKey: this.apllyInfo.id,
        opinion: '1'
      }
      this.$put('/tra/project/modify/audit', form,function(res){
        if (res.code == 200) {
          this.applyInfo();
          this.$parent.applyInfo()
          this.applyVisible = false;
          this.payState = true;
          this.payStates = 1;
          this.payList = res.data;
        }
      },true)
    },

     //申请编辑拒绝
     reCancel() {
      this.waitInfoData.opinion = '2';
      const loading = this.$loading({
        text: '正在提交...',
      })
      this.$post('/activiti/act/audit/pass', this.waitInfoData, function(res){
        if (res.code == 200) {
          loading.close();
          this.applyInfo();
          this.$parent.applyInfo()
          this.applyVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      },true)
    },

    //支付
    nowPay(){
      this.$get('/tra/project/modify/pay/info?traProjectId	=' + this.$route.query.id, function(res){
        if(res.code==200){
          this.payOrder = res.data.payOrder;
          this.wechatPay()
        }
      })
    },

    // 生成微信订单
    wechatPay(){
      var payOrder = this.payOrder
      payOrder.tradeWay = 'W02'; //微信支付
      payOrder.orderType='6';  //
      this.$post('/pay/order/launch',payOrder,function(res){
          if(res.code==200){
              this.payInfo = JSON.parse(res.data.payUrl)
              this.onBridgeReady(this.payInfo)
              this.timer = setInterval(() => {
                  //需要定时执行的代码
                  this.checkResult()
              },1000)
          }
      },true)
    },

     // 调用微信支付
     onBridgeReady(payInfo){ 
          var that= this;
          WeixinJSBridge.invoke( 'getBrandWCPayRequest', 
              { 
                  "appId":payInfo.appId, //公众号ID，由商户传入 
                  "timeStamp":payInfo.timeStamp, //时间戳，自1970年以来的秒数 
                  "nonceStr":payInfo.nonceStr, //随机串 
                  "package":payInfo.package, 
                  "signType":payInfo.signType, //微信签名方式： 
                  "paySign":payInfo.paySign //微信签名 
              }, 
              function(res){ 
                  if(res.err_msg == "get_brand_wcpay_request:ok" ){ 
                      // 使用以上方式判断前端返回,微信团队郑重提示： 
                      //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。 } }); 
                  } 
                  if (typeof WeixinJSBridge == "undefined"){ 
                      if( document.addEventListener ){ 
                          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                      }else if (document.attachEvent){ 
                          document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady); 
                      } 
                  }else{ that.onBridgeReady(); }
              }
          )
      },

      // 查询支付结果
      checkResult(){
          if(this.$route.path.indexOf('/outsourcer/underProInfo')!=-1){
              this.$get('/pay/order/result?id='+this.payOrder.id,function(res){
                  if (res.code == 200) {
                      if(res.data==true){
                          clearInterval(this.timer);
                          this.timer='';
                          if(this.timer==''){
                            this.$parent.projectXn()
                            this.aduitInfo()
                            this.$parent.projectDetail()
                          }
                      }
                  }
              })
          }else{
              clearInterval(this.timer)
              this.timer=''
          }
      },
    //延长保障期列表
    extendInfo(){
      this.$get('/tra/project/ensure/extend/list?traProjectId='+this.$route.query.id,function(res){
        if(res.code==200){
          this.extendList= res.data
        }
      })
    },

    // 查看详情(延长申请列表)
    lookInfo(id){
      this.yancVisible= true
      this.$get('/tra/project/ensure/extend/detail?id='+id, function(res){
        if (res.code == 200) {
          this.yancInfo = res.data;
        }
      })
    },

    // 拨打电话
    callTel(phone){
      const a = document.createElement("a");
      a.href = "tel:"+phone+""
      a.click();
    },

    // 联系专家
    linkPerson(row){
      this.rowid = row.id
      this.getIsExtract()
      this.personVisible= true
    },
    // 中标专家列表
    getIsExtract(){
      let params = { projectId: this.$route.query.id }
        this.$get('/tra/project/bid/meetingList', params,function(res){
          if(res.code==200){
            var list = res.data
            this.extractUserList = list
            this.autoStart()
          }
        })
    },

    getReresh(){
      this.tickers = setInterval(() => {
        if(this.$route.path.indexOf('/outsourcer/underProMeetInfo')!=-1){
          if(this.personVisible==true){
            //需要定时执行的代码
            this.getIsExtract()
          }else{
            clearInterval(this.tickers)
            this.tickers=''
          }
        }else{
          clearInterval(this.tickers)
          this.tickers=''
        }
      },10000)
    },


  },
};
